var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDocuments = function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 2.75A2.75 2.75 0 0 0 7.75 5.5h1.5c0-.69.56-1.25 1.25-1.25h6a2.25 2.25 0 0 1 2.25 2.25v8c0 .69-.56 1.25-1.25 1.25a.75.75 0 0 0 0 1.5 2.75 2.75 0 0 0 2.75-2.75v-8a3.75 3.75 0 0 0-3.75-3.75h-6Zm-3 4a3.75 3.75 0 0 0-3.75 3.75v7a3.75 3.75 0 0 0 3.75 3.75h5a3.75 3.75 0 0 0 3.75-3.75v-7a3.75 3.75 0 0 0-3.75-3.75h-5ZM5.25 10.5A2.25 2.25 0 0 1 7.5 8.25h5a2.25 2.25 0 0 1 2.25 2.25v7a2.25 2.25 0 0 1-2.25 2.25h-5a2.25 2.25 0 0 1-2.25-2.25v-7Zm1.75.75a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5h2.5a.75.75 0 0 0 0-1.5h-2.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgDocuments;